'use client';

import { c as _c } from "react/compiler-runtime";
import { useApi } from '@repo/api';
import { useAccess } from '@repo/auth';
import { permissions } from '@repo/permissions';
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger, SIDEBAR_WIDTH, SidebarHeader, SidebarMenu, SidebarMenuButton, SidebarMenuItem, Skeleton, Spinner } from '@repo/ui/components';
import { ChevronsUpDown, Globe } from '@repo/ui/icons';
import { Suspense } from 'react';
import { useSuspenseQuery } from '@repo/tanstack/query';
import { useOrganisationScope } from '@repo/features/organisations';
import { getScopeOrganisationId } from '@repo/upfetch/core';
import * as React from 'react';
import { getOrganisationLogo, OrganisationLogo } from '@context/companies';
export const AppSidebarHeader = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Fallback />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SidebarHeader data-sentry-element="SidebarHeader" data-sentry-component="AppSidebarHeader" data-sentry-source-file="sidebar-header.tsx"><SidebarMenu data-sentry-element="SidebarMenu" data-sentry-source-file="sidebar-header.tsx"><SidebarMenuItem data-sentry-element="SidebarMenuItem" data-sentry-source-file="sidebar-header.tsx"><Suspense fallback={t0} data-sentry-element="Suspense" data-sentry-source-file="sidebar-header.tsx"><Loader data-sentry-element="Loader" data-sentry-source-file="sidebar-header.tsx" /></Suspense></SidebarMenuItem></SidebarMenu></SidebarHeader>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const Loader = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      permissions: [permissions.organisations.list]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    allowed: canListOrganisations
  } = useAccess(t0);
  if (!canListOrganisations) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SidebarMenuButton size="lg"><CompanyItem name="All" /></SidebarMenuButton>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <OrganisationSwitcher data-sentry-element="OrganisationSwitcher" data-sentry-component="Loader" data-sentry-source-file="sidebar-header.tsx" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const OrganisationSwitcher = () => {
  const $ = _c(33);
  const api = useApi();
  let t0;
  if ($[0] !== api.organisations.list) {
    t0 = api.organisations.list.queryOptions();
    $[0] = api.organisations.list;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data
  } = useSuspenseQuery(t0);
  const {
    scope,
    selectScope
  } = useOrganisationScope();
  let t1;
  if ($[2] !== scope) {
    t1 = getScopeOrganisationId(scope);
    $[2] = scope;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const scopeOrganisationId = t1;
  let t2;
  if ($[4] !== data || $[5] !== scopeOrganisationId) {
    let t3;
    if ($[7] !== scopeOrganisationId) {
      t3 = org => org.id === scopeOrganisationId;
      $[7] = scopeOrganisationId;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = data.find(t3);
    $[4] = data;
    $[5] = scopeOrganisationId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const currentOrg = t2;
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SidebarMenuButton className="data-popup-open:bg-sidebar-accent data-popup-open:text-sidebar-accent-foreground" size="lg" />;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== currentOrg) {
    t4 = currentOrg ? <CompanyItem name={currentOrg.name} slug={currentOrg.slug} /> : <CompanyItem name="All" />;
    $[10] = currentOrg;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ChevronsUpDown className="ml-auto" data-sentry-element="ChevronsUpDown" data-sentry-source-file="sidebar-header.tsx" />;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4) {
    t6 = <DropdownMenuTrigger render={t3} data-sentry-element="DropdownMenuTrigger" data-sentry-source-file="sidebar-header.tsx">{t4}{t5}</DropdownMenuTrigger>;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      "--sidebar-width": SIDEBAR_WIDTH
    };
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <DropdownMenuLabel data-sentry-element="DropdownMenuLabel" data-sentry-source-file="sidebar-header.tsx">Organisations</DropdownMenuLabel>;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== selectScope) {
    t9 = () => {
      selectScope({
        kind: "all"
      });
    };
    $[17] = selectScope;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <CompanyItem name="All" data-sentry-element="CompanyItem" data-sentry-source-file="sidebar-header.tsx" />;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t9) {
    t11 = <DropdownMenuItem onClick={t9} data-sentry-element="DropdownMenuItem" data-sentry-source-file="sidebar-header.tsx">{t10}</DropdownMenuItem>;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== data || $[23] !== selectScope) {
    let t13;
    if ($[25] !== selectScope) {
      t13 = org_0 => <DropdownMenuItem key={org_0.id} onClick={() => {
        selectScope({
          id: org_0.id,
          kind: "organisation"
        });
      }}><CompanyItem name={org_0.name} slug={org_0.slug} /></DropdownMenuItem>;
      $[25] = selectScope;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    t12 = data.map(t13);
    $[22] = data;
    $[23] = selectScope;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t12) {
    t13 = <DropdownMenuContent className="w-[calc(var(--sidebar-width)-1rem)]" style={t7 as React.CSSProperties} data-sentry-element="DropdownMenuContent" data-sentry-source-file="sidebar-header.tsx"><DropdownMenuGroup data-sentry-element="DropdownMenuGroup" data-sentry-source-file="sidebar-header.tsx">{t8}{t11}{t12}</DropdownMenuGroup></DropdownMenuContent>;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13 || $[31] !== t6) {
    t14 = <DropdownMenu data-sentry-element="DropdownMenu" data-sentry-component="OrganisationSwitcher" data-sentry-source-file="sidebar-header.tsx">{t6}{t13}</DropdownMenu>;
    $[30] = t13;
    $[31] = t6;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
};
const CompanyItem = t0 => {
  const $ = _c(8);
  const {
    name,
    slug
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      color: "var(--sidebar-primary-foreground)"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== slug) {
    t2 = <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary dark:bg-accent"><Logos className="size-4" slug={slug} style={t1} data-sentry-element="Logos" data-sentry-source-file="sidebar-header.tsx" /></div>;
    $[1] = slug;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== name) {
    t3 = <span className="text-sm font-semibold">{name}</span>;
    $[3] = name;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
const Logos = t0 => {
  const $ = _c(4);
  const {
    className,
    slug,
    style
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== slug || $[2] !== style) {
    t1 = getOrganisationLogo(slug) ? <OrganisationLogo className={`${className} fill-sidebar-primary-foreground`} slug={slug} /> : <Globe className={className} style={{
      ...style,
      stroke: "var(--sidebar-primary-foreground)"
    }} />;
    $[0] = className;
    $[1] = slug;
    $[2] = style;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
const Fallback = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SidebarMenuButton className="data-popup-open:bg-sidebar-accent data-popup-open:text-sidebar-accent-foreground" size="lg" data-sentry-element="SidebarMenuButton" data-sentry-component="Fallback" data-sentry-source-file="sidebar-header.tsx"><div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground dark:bg-accent"><Spinner className="size-4" data-sentry-element="Spinner" data-sentry-source-file="sidebar-header.tsx" /></div><Skeleton className="h-5 w-36" data-sentry-element="Skeleton" data-sentry-source-file="sidebar-header.tsx" /><ChevronsUpDown className="ml-auto" data-sentry-element="ChevronsUpDown" data-sentry-source-file="sidebar-header.tsx" /></SidebarMenuButton>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};